import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { getIconColorSVGFill } from '../../tools/colors.js';
import css_248z from './icons.styles.css.js';

let LegalIcon = class LegalIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.color = 'iconNeutralSoft';
        this.size = '24';
    }
    render() {
        return html `
      <svg
        width=${`${this.size}px`}
        height=${`${this.size}px`}
        viewBox="0 0 26 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.0376 1.99684L17.8676 4.82684C18.6476 5.60684 18.6476 6.87684 17.8676 7.65684L16.4476 9.07684L10.7976 3.41684L12.2076 2.00684C12.9876 1.21684 14.2576 1.21684 15.0376 1.99684ZM9.37762 4.82684L6.54762 7.65684L19.2776 20.3868C20.0576 21.1668 21.3276 21.1668 22.1076 20.3868C22.8876 19.6068 22.8876 18.3368 22.1076 17.5568L9.37762 4.82684ZM13.3076 20.5868H3.30762C2.75762 20.5868 2.30762 21.0368 2.30762 21.5868C2.30762 22.1368 2.75762 22.5868 3.30762 22.5868H13.3076C13.8576 22.5868 14.3076 22.1368 14.3076 21.5868C14.3076 21.0368 13.8576 20.5868 13.3076 20.5868ZM10.7976 14.7268L5.13762 9.06684L3.72762 10.4768C2.94762 11.2568 2.94762 12.5268 3.72762 13.3068L6.55762 16.1368C7.33762 16.9168 8.60762 16.9168 9.38762 16.1368L10.7976 14.7268Z"
          fill=${this.color ? getIconColorSVGFill(this.color) : 'currentColor'}
        />
      </svg>
    `;
    }
};
LegalIcon.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: String })
], LegalIcon.prototype, "color", void 0);
__decorate([
    property({ type: String })
], LegalIcon.prototype, "size", void 0);
LegalIcon = __decorate([
    customElement('legal-icon')
], LegalIcon);
var LegalIcon$1 = LegalIcon;

export { LegalIcon$1 as default };
//# sourceMappingURL=legalIcon.js.map
